export default {"src":"/_next/static/media/PLUG.323992af.svg","height":18,"width":18};